import { linkFirstAccountData } from "constants-lib/seo/linkFirstAccountData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const getLinkFirstAccountData = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add Link First Account JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addLinkFirstAccountData = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-to-link-up-my-first-account-if-i-just-created-a-my-wm-account`,
    ) &&
    document.getElementById(`linkFirstAccount`) === null
  ) {
    const script = linkFirstAccountDataJSONLD()
    addJSONLDToHead(script, `linkFirstAccount`)
  } else {
    removeElement(`linkFirstAccount`)
  }
}

// JSON LD template for Link First Account
const linkFirstAccountDataJSONLD = () => {
  const linkFirstAccountDataTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getLinkFirstAccountData(linkFirstAccountData),
  }
  return linkFirstAccountDataTemplate
}
